import Handlebars from "handlebars/dist/handlebars.js";
import { Validate } from "../validate";
import { displayGenericError, displayInputErrorMarkup, serviceNetworkError } from "../failhandler";

var myDetails = (function () {
    "use strict";

    if ($('.my-details').length > 0) {

        var validated = true,
            loginForm = $('.login-form'),
            loginResWrapper = $('.login-response-wrapper'),
            resetForm = $('.reset-password-form'),
            resetResWrapper = $('.reset-response-wrapper'),
            registerForm = $('.register-form'),
            editResponseWrap = $('.edit-response-wrapper'),
            addResponseWrap = $('.add-response-wrapper'),
            responseModal = $('.response-modal'),
            editLoadBtn = $('#edit-user'),
            addLoadBtn = $('#add-user'),
            endLoadBtn = $('#end-account'),
            endSource = $('#response-end-template').html(),
            endTemplate = Handlebars.compile(endSource),
            deleteSource = $('#response-delete-template').html(),
            editSource = $('#response-edit-template').html(),
            addSource = $('#response-add-template').html(),
            addTemplate = Handlebars.compile(addSource),
            deleteTemplate = Handlebars.compile(deleteSource),
            editTemplate = Handlebars.compile(editSource),
            clEdit = new CanvasLoader('edit-loader'),
            clAdd = new CanvasLoader('add-loader'),
            clDelete = new CanvasLoader('delete-loader');

        if (Modernizr.touch) {
            var click = 'touchend';
        }

        clEdit.setDiameter(20);
        clEdit.setDensity(17);
        clEdit.setRange(1.1);
        clEdit.setSpeed(1);
        clEdit.setColor('#ffffff');
        clEdit.setFPS(24);


        clAdd.setDiameter(20);
        clAdd.setDensity(17);
        clAdd.setRange(1.1);
        clAdd.setSpeed(1);
        clAdd.setColor('#ffffff');
        clAdd.setFPS(24);

        clDelete.setDiameter(20);
        clDelete.setDensity(17);
        clDelete.setRange(1.1);
        clDelete.setSpeed(1);
        clDelete.setColor('#ffffff');
        clDelete.setFPS(24);

        $('.my-details').on('click', '#edit-user', editUserForm);
        $('.my-details').on('click', '#add-user', addUserForm);
        $('.my-details').on('click', '#end-account', endAccount);
        $('.my-details').on('click', '#delete', deleteAccount);
        $('.my-details').on('click', '#cancel', closeModal);
    }

    function editUserForm(e) {
        e.preventDefault();

        var $this = $(this),
            form = $this.closest('.form'),
            inputs = form.find('.form-item input'),
            inputsToValidate = form.find('.form-item input'),
            data = {},
            hash;

        validated = true;

        inputs.each(function () {
            if (!Validate.validate.call($(this))) {
                validated = false;
            }
            var $this = $(this),
                prop = $this.attr('name'),
                value = $this.val();

            data[prop] = value;
        });

        if (validated) {

            data["username"] = form.find("div.user-name span").html();

            clEdit.show();
            editLoadBtn.addClass('loading');

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.updateDetails,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);

        } else {
            var invalidMessage = editResponseWrap.attr('data-invalid-message');

            editResponseWrap.addClass('error').text(invalidMessage).show();
            return;
        }

        function doneHandler(response) {

            if (response.Success) {

                clEdit.hide();
                editLoadBtn.removeClass('loading');

                editResponseWrap.removeClass('error').text(response.Data.Message).show();

            } else {

                displayInputErrorMarkup(form, response);
                displayGenericError(editResponseWrap, response);

                clEdit.hide();
                editLoadBtn.removeClass('loading');
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            clEdit.hide();
            editLoadBtn.removeClass('loading');
            displayGenericError(editResponseWrap, response);
        }
    }

    function addUserForm(e) {
        e.preventDefault();

        var $this = $(this),
            form = $this.closest('.form'),
            inputs = form.find('.form-item input'),
            textarea = form.find('.form-item textarea'),
            inputsToValidate = form.find('.form-item input'),
            checkbox = form.find('.form-item input[type=checkbox]'),
            data = {},
            hash;

        validated = true;

        inputs.each(function () {
            if (!Validate.validate.call($(this))) {
                validated = false;
            }

            var $this = $(this),
                prop = $this.attr('name'),
                value = $this.val();

            data[prop] = value;
        });

        if (validated) {

            data["comment"] = textarea.val();

            clAdd.show();
            addLoadBtn.addClass('loading');

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.register,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);

        } else {
            var invalidMessage = addResponseWrap.attr('data-invalid-message');

            addResponseWrap.addClass('error').text(invalidMessage).show();
            return;
        }

        function doneHandler(response) {

            var html = addTemplate(response);

            if (response.Success) {

                clAdd.hide();
                addLoadBtn.removeClass('loading');
                inputs.val('');
                textarea.val('');
                checkbox.attr('checked', false);

                addResponseWrap.removeClass('error').html(html).show();

            } else {

                clAdd.hide();
                addLoadBtn.removeClass('loading');

                displayGenericError(addResponseWrap, response);
                displayInputErrorMarkup(form, response);
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            clAdd.hide();
            addLoadBtn.removeClass('loading');
            serviceNetworkError(addResponseWrap);
        }
    }

    function endAccount(e) {

        e.preventDefault();

        var html = endTemplate();

        responseModal.find('.template-container').html(html).end().show();

    }

    function closeModal(e) {
        e.preventDefault();

        responseModal.hide();
    }

    function deleteAccount(e) {
        e.preventDefault();

        var data;

        clDelete.show();
        responseModal.find('.template-container').empty();

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.admin.methods.deleteAccount,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            clDelete.hide();

            if (response.Success) {
                var html = deleteTemplate(response);

                responseModal.find('.template-container').html(html);
            }
            else {
                var errorList = $('<ul class="error-list">'),
                    html = deleteTemplate(response);
                if (response.Errors.GenericErrors.length > 0) {
                    for (var i = 0; i < response.Errors.GenericErrors.length; i++) {
                        errorList.append($('<li>', {
                            text: response.Errors.GenericErrors[i]
                        }));
                    }
                }

                responseModal.find('.template-container').html(html).prepend(errorList);
            }


        }

        function failHandler(response) {
            clDelete.hide();

            var errorList = $('<ul class="error-list">');

            if (response.Errors.GenericErrors.length > 0) {
                for (var i = 0; i < response.Errors.GenericErrors.length; i++) {
                    errorList.append($('<li>', {
                        text: response.Errors.GenericErrors[i]
                    }));
                }
            }

            responseModal.find('.template-container').append(errorList);

        }


    }

})();